var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "show-lx-showLxRecord",
      attrs: {
        "element-loading-text": "拼命加载中",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(0, 0, 0, 0.8)",
      },
    },
    [
      _c("content-header", [
        _c(
          "div",
          {
            staticClass: "header-left-box",
            attrs: { slot: "header-left" },
            slot: "header-left",
          },
          [
            _c(
              "div",
              { staticClass: "return-prev", on: { click: _vm.retuenPrev } },
              [
                _c("span", { staticClass: "icon-box" }, [
                  _c("span", { staticClass: "el-icon-arrow-left" }),
                ]),
                _c("span", { staticClass: "return-text" }, [
                  _vm._v(_vm._s(_vm.$t("showLxRecordStudent.FH"))),
                ]),
              ]
            ),
            _c(
              "content-header-title",
              [
                _vm._t("default", function () {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("showLxRecordStudent.CKLXJL"))),
                    ]),
                  ]
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { attrs: { slot: "header-center" }, slot: "header-center" },
          [_vm._t("header-center")],
          2
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "auth",
                rawName: "v-auth",
                value: [["teacher", "admin", "student"], "pro"],
                expression: "[['teacher', 'admin', 'student'], 'pro']",
              },
            ],
            staticClass: "header-right",
            attrs: { slot: "header-right" },
            slot: "header-right",
          },
          [
            _c(
              "el-button",
              {
                attrs: { plain: "", size: "small" },
                on: {
                  click: () => {
                    _vm.toolg("prev")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("showLxRecordStudent.SYC")))]
            ),
            _c(
              "el-select",
              {
                attrs: { size: "small", placeholder: "" },
                on: { change: _vm.getStatisDetail },
                model: {
                  value: _vm.subVersionKeyId,
                  callback: function ($$v) {
                    _vm.subVersionKeyId = $$v
                  },
                  expression: "subVersionKeyId",
                },
              },
              _vm._l(_vm.titleData.curScoreSortList, function (item) {
                return _c("el-option", {
                  key: item.sortNo,
                  attrs: { label: `第${item.sortNo}次`, value: item.keyId },
                })
              }),
              1
            ),
            _c(
              "el-button",
              {
                attrs: { plain: "", size: "small" },
                on: {
                  click: () => {
                    _vm.toolg("next")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("showLxRecordStudent.XYC")))]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c(
            "div",
            { staticClass: "main-left-box" },
            [
              _c("team-show", { attrs: { planData: _vm.planData } }),
              _c(
                "div",
                { staticClass: "table-box" },
                [
                  _c("c-table", {
                    ref: "c-table",
                    attrs: {
                      tableData: _vm.planData.itemDtoList,
                      ISChangeCheckout: false,
                      tableHeader: _vm.lxTableHeaderPresionComputed,
                      TableHeight: `calc( 100vh - ${375}px )`,
                    },
                    on: { operation: _vm.operation },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isShowAnswer
            ? _c("subject-type", {
                staticClass: "subject-type",
                attrs: { planData: _vm.planData, paperData: _vm.paperData },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }